import KeenSlider from "keen-slider";
initSlider();
function initSlider() {
  function navigation(slider) {
    let wrapper, arrowLeft, arrowRight;

    const observer = new ResizeObserver(function () {
      slider.update();
    });

    function markup(remove) {
      wrapperMarkup(remove);
      arrowMarkup(remove);
    }

    function removeElement(elment) {
      elment.parentNode.removeChild(elment);
    }
    function createDiv(className) {
      var div = document.createElement("div");
      var classNames = className.split(" ");
      classNames.forEach((name) => div.classList.add(name));
      return div;
    }

    function arrowMarkup(remove) {
      if (remove) {
        removeElement(arrowLeft);
        removeElement(arrowRight);
        return;
      }
      arrowLeft = createDiv("arrow arrow--left");
      arrowLeft.addEventListener("click", () => slider.prev());
      arrowRight = createDiv("arrow arrow--right");
      arrowRight.addEventListener("click", () => slider.next());

      wrapper.appendChild(arrowLeft);
      wrapper.appendChild(arrowRight);
    }

    function wrapperMarkup(remove) {
      if (remove) {
        var parent = wrapper.parentNode;
        while (wrapper.firstChild)
          parent.insertBefore(wrapper.firstChild, wrapper);
        removeElement(wrapper);
        return;
      }
      wrapper = createDiv("navigation-wrapper");
      slider.container.parentNode.appendChild(wrapper);
      wrapper.appendChild(slider.container);
    }

    function updateClasses() {
      var slide = slider.track.details.rel;
      slide === 0
        ? arrowLeft.classList.add("arrow--disabled")
        : arrowLeft.classList.remove("arrow--disabled");
      slide === slider.track.details.slides.length - 1
        ? arrowRight.classList.add("arrow--disabled")
        : arrowRight.classList.remove("arrow--disabled");
    }

    slider.on("created", () => {
      markup();
      updateClasses();
      observer.observe(slider.container);
      hidePlaceholder(true);
    });
    slider.on("optionsChanged", () => {
      markup(true);
      markup();
      updateClasses();
    });
    slider.on("slideChanged", () => {
      updateClasses();
    });
    slider.on("destroyed", () => {
      markup(true);
      observer.unobserve(slider.container);
    });
  }
  var sliderEle = document.querySelector("#pc-slider");
  //let rtlView = window.Shopify.locale == "ar" ? true : false;
  if (sliderEle) {
    var slider = new KeenSlider(
      "#pc-slider",
      {
        loop: true,
        rtl: rtlView,
        slides: {
          spacing: 10,
          perView: 2.3,
        },
        breakpoints: {
          "(min-width: 768px)": {
            slides: {
              perView: 5,
              spacing: 24,
            },
          },
          "(min-width: 1024px)": {
            slides: {
              perView: 4,
              spacing: 24,
            },
          },
          "(min-width: 1400px)": {
            slides: {
              perView: 5,
              spacing: 40,
            },
          },
        },
      },
      [navigation]
    );
  }

  function hidePlaceholder(action) {
    if (action) {
      let placeholderEle = document.querySelector("#pc-placeholder");
      let sliderEle = document.querySelector("#pc-slider");
      placeholderEle.classList.add("hide");
      sliderEle.classList.remove("hide");
    }
  }
}

// login form
// login form
class LoginForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.emailInput = this.querySelector('input[name="customer[email]"]');
    this.passwordInput = this.querySelector('input[name="customer[password]"]');
    this.errorField = this.querySelector('[data-role="error-field"]');
    this.submissionButton = this.querySelector('button[type="submit"]');
    this.loginToggle = this.querySelector('[data-action="login-toggle"]');
    this.form.addEventListener("submit", this.formSubmission.bind(this));
    this.emailInput.addEventListener("input", this.emailValid.bind(this));
    this.passwordInput.addEventListener("input", this.passValid.bind(this));

    /// on foucus out error
    this.emailInput.addEventListener("focusout", () => {
      this.emailValidation
        ? this.emailInput.classList.remove("error")
        : this.emailInput.classList.add("error");
    });
    this.passwordInput.addEventListener("focusout", () => {
      this.passValidation
        ? this.passwordInput.classList.remove("error")
        : this.passwordInput.classList.add("error");
    });
    // login toggle scroll top
    this.loginToggle?.addEventListener("click", () => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
    window.addEventListener("load", () => {
      if (window.location.hash == "#recover") {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      }
    });
  }
  emailValid() {
    let emailRegex =
      /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    let emailValue = this.emailInput.value;
    emailRegex.test(emailValue)
      ? (this.emailValidation = true)
      : (this.emailValidation = false);
    this.emailValidation
      ? this.emailInput.classList.remove("error")
      : this.emailInput.classList.add("error");
    this.emailValidation && this.passValidation
      ? this.submissionButton.removeAttribute("disabled")
      : this.submissionButton.setAttribute("disabled", "disabled");
  }
  passValid() {
    let passValue = this.passwordInput.value;
    passValue.trim().length < 1
      ? (this.passValidation = false)
      : (this.passValidation = true);
    this.passValidation
      ? this.passwordInput.classList.remove("error")
      : this.passwordInput.classList.add("error");
    this.emailValidation && this.passValidation
      ? this.submissionButton.removeAttribute("disabled")
      : this.submissionButton.setAttribute("disabled", "disabled");
  }
  // form submission
  formSubmission(e) {
    e.preventDefault();
    this.classList.add("loading");
    let formData = new URLSearchParams(new FormData(this.form)).toString();
    fetch(this.form.action, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData,
    })
      .then((res) => res.text())
      .then((htmlText) => {
        let parser = new DOMParser();
        let loginHtml = parser.parseFromString(htmlText, "text/html");
        let errors = loginHtml.querySelector('[data-role="errors"]');
        if (errors) {
          this.errorField.classList.remove("hidden");
          this.classList.remove("loading");
        } else {
          this.classList.remove("loading");
          this.errorField.classList.add("hidden");
          this.classList.add("success");
          setTimeout(() => {
            window.location.href = `${Shopify.routes.root}account`;
          }, 500);
        }
        errors ? console.log("errors", errors) : console.log("no errors found");
      });
  }
}
customElements.define("login-form", LoginForm);
